module.exports = __webpack_public_path__ + "static/media/melchior.4610db95.jpg";